module.exports = __webpack_public_path__ + "img/online.fb93d2e7.svg";